import React, { useState } from 'react'
import styles from './ArticleComponents.module.css';
import { Button, IconButton } from "@material-ui/core";
import { CopyToClipboard } from "react-copy-to-clipboard";
import {useLocation} from 'react-router-dom'
import Tooltip from '@material-ui/core/Tooltip';
import {Link} from "react-router-dom";


function ArticleCoverAndHeader({children,readTime,title,authorLink,author,previousGuide,nextGuide,authorLink2,author2,Internet}) {

    const location = useLocation()
    const [text, setText] = useState("https://vitrendz-covid19.web.app"+location.pathname);
    const [isCopied, setIsCopied] = useState(false);

    const onCopyText = () => {
        setIsCopied(true);
        setTimeout(() => {
        setIsCopied(false);
        }, 3000);
    };

    return (
        <div className={styles.component}>
            <div className={styles.articleBody}>
                <div className={styles.articleInfo}>
                    <p>
                        <i class="fas fa-book-open"></i>
                        <span>{readTime} min read</span>
                    </p>
                    
                    <CopyToClipboard text={text} onCopy={onCopyText}>
                        <Tooltip title={isCopied ? "Link Copied to Clipboard" : "Share this Article"}>
                            <IconButton className={styles.shareButton}>
                                <i className={isCopied ? `fas fa-check-circle ${styles.colorGreen}` : "fas fa-share-alt-square"}></i>
                            </IconButton>
                        </Tooltip>
                    </CopyToClipboard>
                </div>

                <h1 className={styles.articleHeader}>{title}</h1><br />

                {children}

                <div className={styles.guidesNavigation}>
                    <Link to={previousGuide} className={styles.buttonLink}>
                        <Button
                        variant="contained"
                        color="secondary"
                        size="small"
                        startIcon={<i className="fas fa-chevron-left" />}
                        className={styles.guideNavButtons}
                        disabled={!previousGuide}
                        >
                            Previous
                        </Button>
                    </Link>

                    <Link to={nextGuide} className={styles.buttonLink}>
                        <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        endIcon={<i className="fas fa-chevron-right" />}
                        className={styles.guideNavButtons}
                        disabled={!nextGuide}
                        >
                            Next
                        </Button>
                    </Link>
                </div>
            
            </div>
                
            <div className={styles.credits}>
                <h3>
                    {Internet ? "Compiled from various sources" : "Written by :" }
                    {authorLink2 ? (<br/>) : null}
                    <a
                        href={authorLink}
                        target="_blank"
                        rel="noreferrer"
                        >
                        &nbsp; {author}
                    </a>
                    {Internet ? null : (<span style={{fontSize:'12px',fontWeight:'500'}}>&nbsp; ( VIT-Vellore )</span>)}
                </h3>
                {authorLink2 ? (<h3 style={{marginTop:'-10px'}}>
                    <a
                        href={authorLink2}
                        target="_blank"
                        rel="noreferrer"
                        >
                        &nbsp; {author2}
                    </a>
                    <span style={{fontSize:'12px',fontWeight:'500'}}>&nbsp; ( VIT-Vellore )</span>
                </h3>) : null}
            </div>
        </div>
    )
}

export default ArticleCoverAndHeader
